<template>
  <v-data-table
    :headers="headers"
    :items="invoices"
    :loading="isLoading"
    item-key="id"
  >
    <template slot="items" slot-scope="props">
      <td>{{ props.item.id }}</td>
      <td>{{ props.item.periodStart }}</td>
      <td>{{ props.item.periodEnd }}</td>
      <td>${{ (props.item.total) ? (props.item.total.toFixed(2)) : '0.00' }}</td>
      <td>{{ props.item.dateDue }}</td>
      <td>{{ props.item.datePaid }}</td>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'InvoiceListing',
  data: () => ({
    isLoading: false,
    invoices: [],
    headers: [
      { text: '#', value: 'id' },
      { text: 'Start', value: 'periodStart' },
      { text: 'End', value: 'periodEnd' },
      { text: 'Total', value: 'total' },
      { text: 'Due', value: 'dateDue' },
      { text: 'Paid?', value: 'datePaid' }
    ]
  }),
  props: {
    scope: {
      type: String,
      default: null
    },
    scopeID: {
      type: Number,
      default: null
    }
  },
  mounted: function () {
    let url = '/invoices'
    if (this.scope !== null && this.scopeID !== null) {
      url += '/for/' + this.scope + '/' + this.scopeID
    }
    this.isLoading = true

    this.axios.get(url)
      .then((res) => {
        let invoices = this.invoices = res.data
        let reqs = invoices.map((v) => {
          return this.axios.get('/invoices/' + v.id + '/lines')
        })

        this.axios.all(reqs)
          .then((res) => {
            res.forEach((res) => {
              // Don't bother if we have no line items
              if (res.data.length === 0) {
                return
              }

              // Get a total of all our line items
              let total = res.data.reduce(function (t, v) {
                return t + (v.price * v.qty)
              }, 0)

              // Update our invoice price values
              for (let i in this.invoices) {
                if (this.invoices[i].id === res.data[0].invoiceID) {
                  this.invoices[i].total = total
                }
              }
            })

            this.isLoading = false
          })
          .catch(this.$root.apiErrorHandler())
      })
      .catch(this.$root.apiErrorHandler())
  }
}
</script>
